// Libraries
import styled from "styled-components"


export const VentureAboutNeighborhoodContainer = styled.div`

`

